import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../services/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // null = checking, false = unauthenticated, object = user
    const [user, setUser] = useState(null);

    const refreshMe = useCallback(async () => {
        const token = localStorage.getItem("ns_token");
        if (!token) {
            setUser(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            localStorage.removeItem("ns_token");
            setUser(false);
        }
    }, []);

    useEffect(() => {
        refreshMe();
    }, [refreshMe]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("ns_token", data.access_token);
        setUser(data.user);
        return data.user;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        return data;
    };

    const logout = () => {
        localStorage.removeItem("ns_token");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, login, register, logout, refreshMe }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
